// extracted by mini-css-extract-plugin
export default {"links":"links_links__b67Eq"};